import React from 'react'
import { ArrowTrendingDownIcon, ArrowTrendingUpIcon, MinusIcon } from '@heroicons/react/24/outline'
import { getClassificationTextStyle, resolveClassificationTrend } from '../utils/classificationTrend'

export const ClassificationTrendIcon: React.FC<{
  classification: string | null | undefined
  classificationPrevious: string | null | undefined
  rankMap: Map<string, number>
}> = ({ classification, classificationPrevious, rankMap }) => {
  const trend = resolveClassificationTrend(classification, classificationPrevious, rankMap)
  if (!trend) return null

  const previousLabel = (classificationPrevious || '').trim()
  const tooltip = previousLabel ? `Categoria anterior: ${previousLabel}` : undefined
  const className = 'h-4 w-4 shrink-0'

  if (trend === 'upgrade') {
    return (
      <span className="inline-flex" role="img" aria-label={tooltip} title={tooltip}>
        <ArrowTrendingUpIcon className={`${className} text-green-600 dark:text-green-400`} aria-hidden />
      </span>
    )
  }
  if (trend === 'downgrade') {
    return (
      <span className="inline-flex" role="img" aria-label={tooltip} title={tooltip}>
        <ArrowTrendingDownIcon className={`${className} text-red-600 dark:text-red-400`} aria-hidden />
      </span>
    )
  }
  return (
    <span className="inline-flex" role="img" aria-label={tooltip} title={tooltip}>
      <MinusIcon className={`${className} text-gray-400 dark:text-gray-500`} aria-hidden />
    </span>
  )
}

export const ClassificationLabel: React.FC<{
  classification: string | null | undefined
  colorMap: Map<string, string | null>
  emptyLabel?: string
}> = ({ classification, colorMap, emptyLabel = '—' }) => {
  const label = classification?.trim() || emptyLabel
  if (label === emptyLabel && !classification?.trim()) {
    return <span>{emptyLabel}</span>
  }
  return <span style={getClassificationTextStyle(classification, colorMap)}>{label}</span>
}

export const ClassificationWithTrend: React.FC<{
  classification: string | null | undefined
  classificationPrevious: string | null | undefined
  rankMap: Map<string, number>
  colorMap: Map<string, string | null>
  emptyLabel?: string
  className?: string
}> = ({
  classification,
  classificationPrevious,
  rankMap,
  colorMap,
  emptyLabel = '—',
  className = 'inline-flex items-center gap-1.5',
}) => (
  <span className={className}>
    <ClassificationLabel classification={classification} colorMap={colorMap} emptyLabel={emptyLabel} />
    <ClassificationTrendIcon
      classification={classification}
      classificationPrevious={classificationPrevious}
      rankMap={rankMap}
    />
  </span>
)
